export default {"src":"/_next/static/media/chromeiosmobile.37a2cda9.gif","height":422,"width":918,"blurWidth":0,"blurHeight":0};